"use client";

import { Button } from "@/components/Button";
import { Routes } from "@/lib/routes";
import { useCookieAgreements } from "@/store/cookie-agreements";
import Link from "next/link";
import { usePathname } from "next/navigation";
import styles from "./CookieAgreements.module.css";

export const CookieAgreements = () => {
  const { hasAgreed, isLoading, acceptCookies } = useCookieAgreements();
  const pathname = usePathname();
  const isDocsPage = pathname.includes(Routes.DOCS);

  if (isLoading || isDocsPage || hasAgreed) {
    return null;
  }

  return (
    <div className={styles.cookie}>
      <div className={styles["cookie-content"]}>
        <Link className={styles.link} href={Routes.COOKIES}>
          Мы используем cookies
        </Link>
        <Button variant={"cookie"} onClick={() => acceptCookies(true)}>
          Хорошо
        </Button>
      </div>
    </div>
  );
};
